// Szerokość klasycznego paska przewijania w `--sbw`.
//
// Cały układ frontu skaluje się od `100vw` (patrz `utils/_scale.scss`), a `100vw`
// LICZY pasek przewijania. Na systemach z paskiem zajmującym miejsce w layoucie
// (macOS „Pokaż paski przewijania: zawsze", Windows) sekcje pełnej szerokości
// wychodziły ~15 px poza widoczny obszar i strona dostawała poziomy scroll.
// Stąd `--vwu` = `100vw - var(--sbw)`, czyli realna szerokość treści.
const setScrollbarWidth = () => {
    const sbw = window.innerWidth - document.documentElement.clientWidth;

    // Pasek nakładkowy (macOS domyślnie, mobile) daje 0 — wtedy `--vwu` == `100vw`.
    document.documentElement.style.setProperty('--sbw', `${Math.max(0, sbw)}px`);
};

setScrollbarWidth();
window.addEventListener('resize', setScrollbarWidth);
window.addEventListener('load', setScrollbarWidth);
